export default __webpack_public_path__ + "static/media/java.e9d00830.png";